<template>
	<v-menu
		ref="dateRange"
		v-model="dateRangeMenu"
		nudge-top="-2"
		:close-on-content-click="false"
		transition="slide-y-transition"
		offset-y
		eager
		content-class="date_range_menu"
	>
		<template v-slot:activator="{ on, attrs }">
			<AnemicButton v-bind="attrs" class="date_btn px-2" color="#DFE4EF" height="34" outlined v-on="on" tile>
				<span>
					<SIcon name="date-picker-left"></SIcon>
				</span>
				<span class="pl-1" v-if="!isCustomRange">{{ rangeText }}</span>
				<span v-else class="pl-1"> {{ dateFrom }} - {{ dateTo }} </span>
				<span>
					<v-icon style="font-size: 16px; color: #404d64">mdi-chevron-down</v-icon>
				</span>
			</AnemicButton>
		</template>
		<v-card class="date_range_card" width="480">
			<v-row no-gutters>
				<v-col cols="auto" class="white pa-2 px-0">
					<v-date-picker
						@change="datePickerChanged"
						color="light-blue accent-3"
						no-title
						v-model="dates"
						range
						width="250px"
						:min="minDate"
						:max="maxDate"
					></v-date-picker>
				</v-col>
				<v-col class="text-center" style="background: rgba(33, 39, 62, 0.03)">
					<v-list style="background: transparent">
						<v-list-item
							style="background: transparent; border-bottom: 1px solid #d3dae9; color: #3e495a"
							v-for="item in rangeItems"
							:key="item.name"
							@click="rangeClick(item)"
							>{{ item.name }}</v-list-item
						>
					</v-list>
					<!-- <v-btn depressed color="primary" class="mt-6" @click="dateRangeMenu = false">Done</v-btn> -->
				</v-col>
			</v-row>
			<!-- <v-date-picker v-model="date" no-title @input="dateRangeMenu = false"></v-date-picker> -->
		</v-card>
	</v-menu>
</template>
<script>
import moment from 'moment';
export default {
	name: 'TaskLogListFilterDatePicker',
	props: {
		maxDaysFromToday: { type: Number, default: 30 },
	},
	computed: {
		minDate() {
			if (this.minDateAfterOneSelection) {
				return this.minDateAfterOneSelection;
			}
			const date = new Date();
			const maxDaysAgo = date.getDate() - this.maxDaysFromToday;
			date.setDate(maxDaysAgo);

			return date.toISOString();
		},
		minDateAfterOneSelection() {
			return this.dates?.length === 1 ? this.dates[0] : null;
		},
		maxDate() {
			const date = new Date();
			return date.toISOString();
		},
		isCustomRange() {
			return this.rangeSelected === -1;
		},
		dateTo() {
			if (this.dates[1] && this.dates[1] !== '') {
				return this.formatDate(this.dates[1]);
			} else {
				return null;
			}
		},
		dateFrom() {
			if (this.dates[0] && this.dates[0] !== '') {
				return this.formatDate(this.dates[0]);
			} else {
				return null;
			}
		},
		rangeText() {
			const obj = this.rangeItems.find((o) => o.value == this.rangeSelected);
			if (obj) {
				return obj.name;
			} else {
				return '';
			}
		},
	},
	watch: {
		date(val) {
			this.dateFormatted = this.formatDate(val);
		},
		rangeSelected: {
			handler(n) {
				if (this.rangeSelected === -1) {
					return;
				}
				let today = moment.utc().set({ hour: 0, minute: 0, second: 0, millisecond: 0 });
				const rangeDay = moment(today).subtract(n, 'days');
				if (n === 1) {
					// Hack for just yesterday
					today = rangeDay;
				}
				const t = today.format('YYYY-MM-DD');
				const s = rangeDay.format('YYYY-MM-DD');
				this.$set(this.dates, 0, s);
				this.$set(this.dates, 1, t);
			},
			immediate: true,
		},
		dates: {
			handler() {
				this.$emit('update:dateRange', this.dates);
			},
			immediate: true,
		},
	},
	methods: {
		rangeClick(range) {
			this.rangeSelected = range.value;
		},
		formatDate(date) {
			if (!date) return null;
			const [year, month, day] = date.split('-');
			return `${month}/${day}/${year}`;
		},
		datePickerChanged() {
			this.rangeSelected = -1;
		},
	},
	data: (vm) => ({
		rangeSelected: 30,
		rangeItems: [
			{ name: 'Today', value: 0 },
			{ name: 'Yesterday', value: 1 },
			{ name: 'Last 7 days', value: 7 },
			{ name: 'Last 30 days', value: 30 },
		],
		dates: ['', ''],
		date: new Date().toISOString().substr(0, 10),
		dateFormatted: vm.formatDate(new Date().toISOString().substr(0, 10)),
		dateRangeMenu: false,
	}),
};
</script>
<style scoped>
.date_btn {
	height: 33px !important;
	font-size: 14px !important;
	color: #6e7986 !important;
	border-radius: 8px !important;
	letter-spacing: 0px !important;
	font-weight: normal !important;
	text-transform: none !important;
	background: #ffffff !important;
	border: 1px solid #dfe4ef !important;
}

.v-btn--outlined {
	border-radius: 7px !important;
	border-color: #dfe4ef !important;
}

/*.date_range_menu{border:1px solid #E7E7ED !important;box-shadow: none !important;border-radius: 7px !important}*/
</style>
